(function () {
  var MAX_FILE_SIZE = 10 * 1024 * 1024;
  var UNIT_PRICE = 25;
  var MAX_QTY = 20;

  function formatSize(bytes) {
    return (bytes / (1024 * 1024)).toFixed(1) + 'MB';
  }

  function init() {
    var checkbox   = document.getElementById('CartDrawerLogoCheckbox');
    var form       = document.getElementById('CartDrawerLogoForm');
    var fileInput  = document.getElementById('CartDrawerLogoFile');
    var contact    = document.getElementById('CartDrawerLogoContact');
    var submitBtn  = document.getElementById('CartDrawerLogoSubmit');
    var status     = document.getElementById('CartDrawerLogoStatus');
    var qtyInput   = document.getElementById('CartDrawerLogoQty');
    var qtyDisplay = document.getElementById('CartDrawerLogoQtyDisplay');
    var qtyMinus   = document.getElementById('CartDrawerLogoQtyMinus');
    var qtyPlus    = document.getElementById('CartDrawerLogoQtyPlus');
    var priceLabel = document.getElementById('CartDrawerLogoPrice');

    // Bail if elements not found
    if (!checkbox || !form) return;

    function qty() { return parseInt(qtyInput.value, 10) || 1; }

    function setQty(n) {
      qtyInput.value = n;
      if (qtyDisplay) qtyDisplay.textContent = n;
      if (priceLabel) {
      var total = UNIT_PRICE * n;
      priceLabel.textContent = n > 1 ? '$' + total + ' ($25 each)' : '$25 each';
    }
    }

    // Show/hide form on checkbox change — simple display toggle, no animation dependency
    checkbox.addEventListener('change', function () {
      form.style.display = checkbox.checked ? 'flex' : 'none';
      if (status) status.textContent = '';
    });

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function (e) {
        e.preventDefault();
        if (qty() > 1) setQty(qty() - 1);
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function (e) {
        e.preventDefault();
        if (qty() < MAX_QTY) setQty(qty() + 1);
      });
    }

    fileInput.addEventListener('change', function () {
      if (status) status.textContent = '';
      if (fileInput.files.length && fileInput.files[0].size > MAX_FILE_SIZE) {
        status.textContent = 'File is ' + formatSize(fileInput.files[0].size) + ' — please upload something under 10MB.';
        fileInput.value = '';
      }
    });

    form.addEventListener('submit', function (e) {
      if (status) status.textContent = '';
      if (!fileInput.files.length) {
        e.preventDefault();
        status.textContent = 'Please choose a logo file.';
        return;
      }
      if (fileInput.files[0].size > MAX_FILE_SIZE) {
        e.preventDefault();
        status.textContent = 'File is ' + formatSize(fileInput.files[0].size) + ' — please upload something under 10MB.';
        return;
      }
      if (!contact.value.trim()) {
        e.preventDefault();
        status.textContent = 'Please add your email or Instagram handle.';
        return;
      }
      // Return to current page so cart drawer stays accessible
      var returnInput = form.querySelector('input[name="return_to"]');
      if (returnInput) returnInput.value = window.location.pathname;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
    });
  }

  // Run now if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also re-init if the cart drawer re-renders (Shopify replaces DOM on cart updates)
  document.addEventListener('cart:refresh', init);
})();